import { Link, useNavigate } from 'react-router-dom';
import {
  SongCardActionButton,
  SongCardActionRow,
  SongCardContainer,
  SongCardContent,
  SongCardMeta,
  SongCardNote,
  SongCardTitle,
  SongCardTitleArtist,
} from './styled';

function SongCard({
  song,
  note,
  to,
  secondaryActionLabel,
  secondaryActionTo,
  secondaryActionTone = 'neutral',
  actionLabel,
  actionLoadingLabel,
  actionTone = 'neutral',
  isActionPending = false,
  onAction,
  compact = false,
}) {
  const navigate = useNavigate();
  const title = song.title || 'Untitled song';
  const artist = song.artist || 'Unknown artist';
  const songRoute = to || `/song/${song._id}`;

  const handleOpenSong = () => {
    navigate(songRoute);
  };

  const handleCardKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpenSong();
    }
  };

  const handleActionClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onAction?.(song);
  };

  return (
    <SongCardContainer $compact={compact}>
      <SongCardContent
        role="button"
        tabIndex={0}
        $compact={compact}
        onClick={handleOpenSong}
        onKeyDown={handleCardKeyDown}
      >
        {compact ? (
          <SongCardTitle $compact>
            {title}{' '}
            <SongCardTitleArtist>({artist})</SongCardTitleArtist>
          </SongCardTitle>
        ) : (
          <>
            <SongCardMeta>{artist}</SongCardMeta>
            <SongCardTitle>{title}</SongCardTitle>
          </>
        )}
        {note ? <SongCardNote>{note}</SongCardNote> : null}
      </SongCardContent>

      {actionLabel && onAction ? (
        <SongCardActionRow>
          {secondaryActionLabel && secondaryActionTo ? (
            <SongCardActionButton
              as={Link}
              to={secondaryActionTo}
              $tone={secondaryActionTone}
              onClick={(event) => event.stopPropagation()}
            >
              {secondaryActionLabel}
            </SongCardActionButton>
          ) : null}
          <SongCardActionButton
            type="button"
            $tone={actionTone}
            onClick={handleActionClick}
            disabled={isActionPending}
          >
            {isActionPending ? actionLoadingLabel || actionLabel : actionLabel}
          </SongCardActionButton>
        </SongCardActionRow>
      ) : secondaryActionLabel && secondaryActionTo ? (
        <SongCardActionRow>
          <SongCardActionButton
            as={Link}
            to={secondaryActionTo}
            $tone={secondaryActionTone}
            onClick={(event) => event.stopPropagation()}
          >
            {secondaryActionLabel}
          </SongCardActionButton>
        </SongCardActionRow>
      ) : null}
    </SongCardContainer>
  );
}

export default SongCard;
